<template>
  <a-col>
    <a-modal
        :title="title"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
        :destroyOnClose="true"
        cancelText="关闭"
        okText="确定"
      >
        <a-spin :spinning="confirmLoading">
          <a-form :form="form">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务名称">
              <a-input placeholder="请输入任务名称" v-decorator="['taskName', validatorRules.taskName]" />
            </a-form-item>
            <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="矢量来源">
              <a-radio-group v-model="taskType" :disabled="isEdit">
                <a-radio :value="1">新建矢量</a-radio>
                <a-radio :value="2">上传矢量修改</a-radio>
               <a-radio :value="3">原有矢量修改</a-radio>
              </a-radio-group>
            </a-form-item> -->
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="矢量文件" v-if="taskType === 2 && !isEdit">
              <a-upload-dragger
                name="file"
                :fileList="fileList"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
              >
                <p class="ant-upload-text">文件拖到此处上传</p>
                <p class="ant-upload-hint" style="color: #ff8000">
                  上传文件必须为ZIP格式，请注意字段对应及数据标准，文件大小不超过50M
                </p>
              </a-upload-dragger>
              </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="原有任务" hasFeedback v-if="taskType === 3">
              <a-select  :size="selectSize" default-value="请选择原有任务"  show-search  option-filter-prop="children" :filter-option="filterOption"  allowClear >
                <a-select-option v-for="i in taskList" :key="i.id" @click="selectListChange(i)" >
                  {{ i.taskName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文件编码" hasFeedback v-if="taskType != 3">
              <!-- <j-dict-select-tag
                v-model="encrypt"
                placeholder="请选择文件编码"
                style="width:100%"
                dictCode="encrypt"
                :disabled="isEdit"
              /> -->
              <a-select  :size="selectSize" default-value="请选择文件编码" v-model="encrypt" :disabled="isEdit">
                <a-select-option v-for="i in encryptList" :key="i.key" @click="getEncrypt(i)">
                  {{ i.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="几何图形类型"  hasFeedback v-if="taskType != 3">
              <!-- <j-dict-select-tag
                v-model="geometryType"
                placeholder="请选择几何图形类型"
                style="width:100%"
                dictCode="geometry_type"
                :disabled="isEdit"
              /> -->
              <a-select  :size="selectSize" default-value="请选择几何图形类型"  v-model="geometryType" :disabled="isEdit">
                <a-select-option v-for="i in geometryTypeList" :key="i.key" @click="getGeometryType(i)">
                  {{ i.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="坐标系"  hasFeedback v-if="taskType != 3">
<!--               <j-dict-select-tag
                v-model="coordinateSystem"
                placeholder="请选择坐标系"
                style="width:100%"
                dictCode="coordinate_system"
                :disabled="isEdit"
              /> -->
              <a-select  :size="selectSize" default-value="请选择坐标系" v-model="coordinateSystem" :disabled="isEdit">
                <a-select-option v-for="i in coordinateSystemList" :key="i.key" @click="getCoordinateSystem(i)">
                  {{ i.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设置标签">
                <template v-for="(tag) in tags">
                  <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
                    <a-tag :key="tag" :closable="true" @close="() => handleClose(tag)">
                      {{ `${tag.slice(0, 20)}...` }}
                    </a-tag>
                  </a-tooltip>
                  <a-tag v-else :key="tag" :closable="true" @close="() => handleClose(tag)">
                    {{ tag }}
                  </a-tag>
                </template>
                <a-input
                  v-if="inputVisible"
                  ref="input"
                  type="text"
                  size="small"
                  :style="{ width: '78px' }"
                  :value="inputValue"
                  @change="handleInputChange"
                  @blur="handleInputConfirm"
                  @keyup.enter="handleInputConfirm"
                />
                <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
                  <a-icon type="plus" /> 添加标签
                </a-tag>
            </a-form-item>
            <!-- table区域-begin -->
            <a-card :bordered="false">
              <!-- 操作按钮区域 -->
              <div class="table-operator">
                <a-button @click="handleAddImage()" type="primary" icon="plus">添加影像服务</a-button>
                <p style="color: #ff8000;">注：添加多个影像时,先加的影像在下方</p>
              </div>
               <div>
                 <a-table
                   size="small"
                   bordered
                   rowKey="id"
                   :columns="columns1"
                   :dataSource="dataSource1"
                   :pagination="false"
                 >
                   <span slot="imageUrl" slot-scope="text">
                     <span :title="text">{{text}}</span>
                   </span>
                    <span slot="action" slot-scope="text, record">
                       <a-popconfirm title="确定移除吗?" @confirm="() => handleDetach(record)">
                              <a>移除</a>
                       </a-popconfirm>
                    </span>
                 </a-table>
               </div>
            </a-card>
          </a-form>
        </a-spin>
      </a-modal>


    <!-- 新增影像服务的表单 -->
    <a-modal
      :title="imageChoose"
      :width="800"
      :visible="imageVisible"
      :confirmLoading="confirmLoading"
      @ok="handleImageOk"
      @cancel="handleImageCancel"
      :destroyOnClose="true"
      cancelText="关闭"
      okText="确定"
      >
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="16" :sm="16">
              <a-form-item label="影像名称">
                <a-input placeholder="请输入影像名称" v-model="searchImagename"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      
      <a-table
        rowKey="id"
        :columns="columnsURL"
        :dataSource="dataSourceURL"
        ref="table"
        size="middle"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
      <span slot="action" slot-scope="text, record">
        <a @click="seeImage(record)">预览</a>
      </span>
      </a-table>
      <!-- <a-form :form="imageForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="影像地址">
          <a-input placeholder="请输入影像地址" v-model="imageUrl" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="影像日期">
          <a-month-picker placeholder="选择影像日期" @change="onChange" style="width: 100%">
          </a-month-picker>
        </a-form-item>
      </a-form> -->
    </a-modal>
    <!-- 影像预览的表单 -->
    <a-modal
      :title="imageSee"
      :width="800"
      :visible="imageSeeVisible"
      @ok="handleImageSee"
      @cancel="handleImageSee"
      cancelText="关闭">
      <!-- 查询区域 -->
      <div style="height: 400px">
        <small-map ref="smallMap"></small-map>
      </div>
    </a-modal>
  </a-col>
</template>

<script>
// import { httpAction,getAction } from '../../api/manage'

import pick from 'lodash.pick'
import SmallMap from "@/components/Maps/SmallMap";
 import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
 import { mapGetters } from 'vuex'
export default {
  name: 'NewShpModal',
  components: {
      SmallMap
  },
  data() {
    return {
      description: '新增影像标注任务表单',
      formData: {},
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      imageForm: this.$form.createForm(this),
      validatorRules: {
        taskName: { rules: [{ required: true, message: '请输入任务名称!' }] },
      },
      url: {
        add: '/task/task/addMarkTask',
        edit: '/task/task/editMarkTask',
        getUnSelectImageList:'/image/image/queryUnSelectImageList',
        getMarkTagsByTaskId:'/task/task/queryMarkTagsByTaskId',
        getManagerMarkTask: "/task/task/queryManagerMarkTask",
        getMarkImageByTaskId:'/task/task/queryMarkImageList',
        importShapeTask: "/task/task/importShapeTask",
      },
      encryptList:[
        {key:'utf-8',value:'utf-8'}
      ],
      encrypt: 'utf-8',
      geometryTypeList:[
        {key:'Point',value:'Point'},
        {key:'Line',value:'Line'},
        {key:'Polygon',value:'Polygon'},
      ],
      geometryType: '',
      coordinateSystem: 'EPSG:4490-CGCS2000',
      coordinateSystemList:[
      {key:'EPSG:4490-CGCS2000',value:'EPSG:4490-CGCS2000'}
      ],
      tags: [],
      inputVisible: false,
      inputValue: '',
      imageId:[],
      imageList:[],
      //选择的服务地址
      columns1: [
        {
          title: '服务名称',
          dataIndex: 'imageName',
          width:"40%",
          scopedSlots:{customRender:"imageUrl"},
          ellipsis:true
        },
        {
          title: '服务日期',
          dataIndex: 'imageDate',
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource1: [],
      imageVisible:false,
      imageUrl:'',
      //存在数据库的服务地址
      imageChoose:'选取标注影像',
      columnsURL: [
        {
          title: '服务名称',
          dataIndex: 'name',
          width:"40%",
          scopedSlots:{customRender:"imageUrl"},
          ellipsis:true
        },
        {
          title: '服务日期',
          dataIndex: '',
          customRender: function(t, r, index) {
            if(t.quarter != null){
              return t.year + '-' + t.quarter
            }else{
              return t.year
            }
          }
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSourceURL:[],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: false,
        total: 0
      },
      selectedRowKeys: [],
      selectionRows: [],
      searchImagename:'',
      imageSee:'影像预览',
      imageSeeVisible:false,
      firstAddMap:true,
      taskType:1,
      taskList:[],
      selectSize:'default',
      fileListLength: 0,
      fileList: [],
      taskId:'',
      isEdit:false,
    }
  },
  mounted(){
    this.imageSeeVisible = true
    this.imageSeeVisible = false
    // this.loadManagerMarkTask()

  },
  methods: {
    getEncrypt(i){
      this.encrypt = i.value
    },
    getGeometryType(i){
      this.geometryType = i.value
    },
    getCoordinateSystem(i){
      this.coordinateSystem = i.value
    },
    ...mapGetters(['nickname', 'avatar', 'device', 'theme', 'color', 'token', 'username', 'welcome', 'permissionList', 'userInfo', 'addRouters', 'departname']),
    //初始化：加载该管理员创建的标注任务
    loadManagerMarkTask(){
      let that = this;
      // getAction(that.url.getManagerMarkTask, { createBy: this.userInfo().username}).then((res) => {
      //   if (res.success) {
      //     this.taskList = [];
      //     if(res.result.length > 0){
      //       for (let i = 0; i < res.result.length; i++){
      //         let temp = res.result[i];
      //         this.taskList.push(temp);
      //       }
      //     }
      //   }
      // });
    },
    selectListChange(i){
      this.taskId = i.id;
      this.geometryType = i.geometryType;
      this.loadMarkTagsByTaskId(i.id);
    },
    //影像名称过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    add (id) {
      this.projectId=id
      this.model={};
      this.imageId = [];
      this.tags = [];
      this.encrypt = 'utf-8';
      this.geometryType = '';
      this.coordinateSystem = 'EPSG:4490-CGCS2000';
      this.form.resetFields();
      this.dataSource1=[]
      this.loadUnSelectImage();
      this.visible = true;
      //编辑时进入
      this.isEdit = false
      },
    edit (record) {
      this.projectId=record.projectId
      this.form.resetFields();
      //编辑时进入
      this.isEdit = true;
      this.loadUnSelectImage();
      this.model = Object.assign({}, record);
      this.encrypt = record.encrypt;
      this.geometryType = record.geometryType;
      this.coordinateSystem = record.coordinateSystem;
      this.taskType = 1
      // this.taskType = Number(record.taskType);
      //根据任务id查询标签和影像
      // this.loadMarkTagsByTaskId(record.id);
      this.tags = record.markTags;
      this.dataSource1 = record.imageUrls
      // this.loadMarkImageByTaskId(record.id);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'taskName'));
      });
    },
    close() {
      // this.$emit('close')
      this.visible = false
    },
    //提交新增标注任务
    handleOk() {
      let that = this;
      that.imageId =[]
      for(let i=0;i<that.dataSource1.length;i++){
        that.imageId.push(that.dataSource1[i].imageUrl)
      }
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err){
          // this.imageId = ["1582632739896877057"]
          if(this.imageId.length === 0){
              that.$message.warning("必须选择影像地址");
              return;
            }
          that.confirmLoading = true;
          let httpUrl = '';
          let method = '';
          if(!this.model.id){
            httpUrl += '/tiles_back/markTask/addMarkTask';
            method = 'post';
          }else{
            httpUrl += this.url.edit;
            method = 'put';
          }
          // that.projectId = '123456'
          let temp = {
            "encrypt": this.encrypt,
            "geometryType": this.geometryType,
            "coordinateSystem":this.coordinateSystem,
            "markTags" :this.tags,
            "imageUrls":that.dataSource1,
            "taskType":this.taskType,
            "taskId":this.taskId,

            projectId:that.projectId
          };
          let formData = Object.assign(this.model, values,temp,this.formData);
          if(that.taskType === 1 && !this.isEdit){
            this.axios
                .post(httpUrl, formData,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((response) => {
                  if(response.status == 200){
                    that.$message.success('创建成功');
                    bus.$emit('update',that.projectId)
                  }
                  else{
                    that.$message.warning('创建失败');
                  }
            
                  }).finally(() => {
                    that.confirmLoading = false;
                    that.close();
                  })

          }
          else if(that.taskType === 1 && this.isEdit){
            let httpUrl = '/tiles_back/markTask/editMarkTask'
            this.axios
                .put(httpUrl, formData,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((response) => {
                  if(response.status == 200){
                    that.$message.success('编辑成功');
                    bus.$emit('update',that.projectId)
                  }
                  else{
                    that.$message.warning('编辑失败');
                  }
            
                  }).finally(() => {
                    that.confirmLoading = false;
                    that.close();
                  })

          }
          // else if(that.taskType === 2){
          //   httpAction(httpUrl,formData,method).then((res)=>{
          //     if(res.success){
          //       let markTask = res.result;
          //       //import shape
          //       const {fileList} = this;
          //       const that = this;
          //       this.confirmLoading = true;
          //       let method = 'post';
          //       let fileData = new FormData();
          //       fileData.append("importShapeFile", fileList[0]);
          //       fileData.append("taskId",markTask.id);
          //       fileData.append("geometryType",that.geometryType);
          //       //执行上传shp文件操作
          //       httpAction(that.url.importShapeTask, fileData, method).then((res) => {
          //         if (res.success) {
          //           that.$message.success(res.message);
          //           that.$emit('ok');
          //         } else {
          //           that.$message.warning(res.message);
          //         }
          //       }).catch(err => {
          //         console.log(err);
          //       });
          //     }
          //   }).finally(() => {
          //     that.confirmLoading = false;
          //     that.close();
          //   })
          // }
          // else if(that.taskType === 3){
          //   httpAction(httpUrl,formData,method).then((res)=>{
          //     if(res.success){
          //       that.$message.success(res.message);
          //       //还需要导入原有数据到数据库
          //       that.$emit('ok');
          //     }else{
          //       that.$message.warning(res.message);
          //     }
          //   }).finally(() => {
          //     that.confirmLoading = false;
          //     that.close();
          //   })
          // }
        }
      });
    },
    getKey() {
            return localStorage.getItem("token");
          },
    //标注任务关闭
    handleCancel() {
      this.close()
      this.dataSource1=[]
    },
    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag);
      this.tags = tags;
    },
    //加载影像列表  全部的
    loadUnSelectImage(){
      let that = this;
      let param=new FormData();
            param.append('program_id',that.projectId);
            param.append('pageNum',that.ipagination.current);
            param.append('name',that.searchImagename);
            param.append('pageSize',10);
            this.axios
                .post("/map_service_back/program/getTileUrls", param,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((res) => {
                  that.dataSourceURL = [];
                  for (let i = 0; i < res.data.data.length; i++) {
                    let temp = res.data.data[i];
                    let flag = true;
                    for(let j=0;j<that.dataSource1.length;j++){
                      if(that.dataSource1[j].imageUrl === temp.url){
                        flag = false
                      }
                    }
                    if(flag){
                      that.dataSourceURL.push(temp);
                    }
                  }
                  that.ipagination.total = res.data.total;
                })
    },
    //加载标注任务的标签列表
    loadMarkTagsByTaskId(taskId){
      let that = this;
      // getAction(that.url.getMarkTagsByTaskId, { taskId: taskId}).then((res) => {
      //   if (res.success) {
      //     this.tags = [];
      //     if(res.result.length > 0){
      //       for (let i = 0; i < res.result.length; i++){
      //         let temp = res.result[i].text;
      //         this.tags.push(temp);
      //       }
      //     }
      //   }
      //   if(res.code===510){
      //     this.$message.warning(res.message)
      //   }
      // });
    },
    //加载标注任务的影像
    loadMarkImageByTaskId(taskId){
      let that = this;
      // getAction(that.url.getMarkImageByTaskId, { taskId: taskId}).then((res) => {
      //   if (res.success) {
      //     this.dataSource1 = [];
      //     if(res.result.length > 0){
      //       for (let i = 0; i < res.result.length; i++){
      //         let temp = res.result[i];
      //         this.dataSource1.push(temp);
      //       }
      //     }
      //   }
      //   if(res.code===510){
      //     this.$message.warning(res.message)
      //   }
      // });
    },
     //点击添加影像服务地址按钮
    handleAddImage(){
      this.searchImagename = ''
      this.ipagination.current = 1;
      if(this.dataSource1.length > 4){
        this.$message.warning("最多可添加5个影像，请先删除！");
      }
      else{
        this.getCurrentTime();
        this.imageUrl = '';
        this.createTime = '';
        this.imageVisible = true;
      }
      this.loadUnSelectImage()
    },
    onChange(date, dateString) {
      this.createTime = dateString;
    },
    //点击确定将影像服务添加到列表中
    handleImageOk(){
      const that = this;
      let flag = false;
      that.dataSource2 =[]
      // 触发表单验证
      if(that.selectionRows.length >5){
        that.$message.warning("最多可选取5个影像");
      }
      else{
        if(this.dataSource1.length + that.selectionRows.length >5){
          that.$message.warning("最多可选取5个影像");
        }else{
          for(let i=0;i<that.selectionRows.length;i++){
            if(that.selectionRows[i].quarter != null && that.selectionRows[i].quarter != ''){
              that.dataSource2.push({id:that.selectionRows[i].mk_id,imageName:that.selectionRows[i].name,imageUrl:that.selectionRows[i].url,imageDate:that.selectionRows[i].year +'-'+that.selectionRows[i].quarter});
            }else{
              that.dataSource2.push({id:that.selectionRows[i].mk_id,imageName:that.selectionRows[i].name,imageUrl:that.selectionRows[i].url,imageDate:that.selectionRows[i].year});
            }
          }
          
        }
      }
      let num = 0
      let allData = that.dataSource2.length
      
      for(let i=0;i<that.dataSource2.length;i++){
        let record = that.dataSource2[i]
        let mk = record.imageUrl.match(/mk=(\S*)&tk/)[1]; //获取url layers到&styles中间部分
        let pro = record.imageUrl.match(/pro=(\S*)/)[1]; //获取url layers到&styles中间部分
        if (mk && pro) {
          let param=new FormData();
            param.append('program_id',pro);
            param.append('mk',mk);
          this.axios
                .post("/map_service_back/program/getExtentByProgram", param,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((response) => {
                    if(response.data.code == 500){
                        that.$message.warning(response.data.message + '(' + record.imageName + ')');
                        that.dataSource2=[]
                    }else{
                      num = num +1;
                    }
                    if(num == allData){
                      that.imageVisible = false;
                      for(let i=0;i<that.dataSource2.length;i++){
                        that.dataSource1.push(that.dataSource2[i])
                      }
                      
                    }
                })
            .catch(function(error) {
              console.log(error)
            })
        }
      }
      
      that.selectedRowKeys =[]
      
    },
    //关闭按钮
    handleImageCancel(){
      this.imageVisible = false;
      this.selectedRowKeys =[]
    },
    //移除新增的影像服务地址
    handleDetach(record){
      let that = this;
      const dataSource1 = [...that.dataSource1];
      that.dataSource1 = dataSource1.filter(item => item.id !== record.id);
    },
    //获取当前的系统时间，用于生成表格id
    getCurrentTime() {
      //获取当前时间并打印
      let _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
      this.imageId = yy + '' + mm +'' + dd + '-'+ hh + '' + mf + '' + ss;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function() {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      });
    },
    //影像列表界面
    //查询影像列表
    searchQuery(){
      this.ipagination.current = 1;
      this.loadUnSelectImage();
    },
    //重置按钮
    searchReset(){
      this.searchImagename = '';
      this.ipagination.current = 1;
      this.loadUnSelectImage();
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.loadUnSelectImage();
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    seeImage(record){
      let that = this;
      that.imageSeeVisible = true;
      that.$nextTick(function () {
        if(that.firstAddMap){
          that.$refs.smallMap.initMap();
          that.firstAddMap = false
        }
        that.$refs.smallMap.addUrlToMapRe(record.name,record.url,record.extent);
      });
    },
    handleImageSee(){
      this.imageSeeVisible = false
    },
    //
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      this.fileListLength++;
      if (this.fileListLength > 1) {
        this.fileList.splice(1)
      }
      return false;
    },
  }
}
</script>

<style lang="less" scoped></style>
